module.exports = __webpack_public_path__ + "img/icon-share-black.096b7ef3.svg";